import { useState, useCallback, useEffect } from 'react';
import { queueApi } from '../services/api';

/** Faol marshrut, foydalanuvchi buyurtmasi va navbat holati */
export function useFleetStatus(pollMs = 10000) {
  const [fleet, setFleet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const data = await queueApi.getFleetStatus();
      setFleet(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    if (!pollMs) return undefined;
    const id = setInterval(refresh, pollMs);
    return () => clearInterval(id);
  }, [refresh, pollMs]);

  return { fleet, loading, error, refresh };
}
